import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29a4d65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-title" }, "登录/注册", -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = {
  key: 1,
  class: "orange"
}
const _hoisted_5 = { class: "foot-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 注册登录即表示同意 "),
  /*#__PURE__*/_createElementVNode("a", { href: "/videoList" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "orange" }, "用户许可协议、用户隐私协议")
  ])
], -1))

import { Toast } from 'vant';
import { ref, watch, onMounted } from 'vue';
import { UserService } from '../api/request';
import { ElLoading, ElMessage } from 'element-plus';
interface EmitsType {
  (e: 'update:confirm'): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  showLogin: {
    type: Boolean,
    default: false
  }
},
  emits: ["update:confirm"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const loginVisible = ref(false);
const account = ref();
const countTime = ref(60);
const showCode = ref(false);
const valicode = ref();



watch(
  () => countTime.value,
  (val) => {
    if (val === 0) {
      showCode.value = false;
    }
  }
);
watch(
  () => props.showLogin,
  (val) => {
    console.log(loginVisible, props.showLogin);
    loginVisible.value = val;
  }
);

onMounted(() => {
  // loginVisible.value = !window.localStorage.getItem('authToken');
});

const handleClose = (done: () => void) => {
  loginVisible.value = false;
  emit('update:confirm');
  done();
};

const sendCode = async() => {
  var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
  if (!myreg.test(account.value)) {
    ElMessage.error('请输入正确的手机号');
    return;
  }
  const authCodeParams = { mobile: account.value };
  const res = await UserService.getAuthCode(authCodeParams);
  if (res.code === '00') {
    showCode.value = true;
    setInterval(() => {
      countTime.value--;
    }, 1000);
    checkLoginOrRegister();
  }
};

const checkLoginOrRegister = async() => {
  const authCodeParams = { mobile: account.value };
  UserService.checkLoginOrRegister(authCodeParams);
};

// eslint-disable-next-line no-redeclare
const login = async() => {
  if (!account.value || !valicode.value) {
    ElMessage.error('请填写完整的信息');
    return;
  }
  const loading = ElLoading.service({
    lock: true,
    text: '登陆中',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  const params = {
    mobile: account.value,
    valicode: valicode.value,
    notPrompt: 1,
    bindType: 1,
    regChannel: 11
  };
  const res = await UserService.login(params);
  loading.close();
  if (res.code === '00') {
    window.localStorage.setItem('authToken', res.body.auth_token);
    window.localStorage.setItem('headImg', res.body?.userInfo?.headImg);
    window.localStorage.setItem('realName', res.body?.userInfo?.realName);
    window.localStorage.setItem('userId', res.body?.userInfo?.userId);
    location.reload();
    loginVisible.value = false;
  }
};

const telFun = (tels: any) => {
  var myreg = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
  if (!myreg.test(tels)) {
    return false;
  } else {
    return true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: loginVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((loginVisible).value = $event)),
      class: "login-dialog",
      width: "400px",
      "before-close": handleClose
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_field, {
            class: "login-ipt",
            modelValue: account.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((account).value = $event)),
            maxlength: 11,
            type: "digit",
            border: false,
            "left-icon": "user-o",
            placeholder: "请输入账号"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            class: "login-ipt",
            modelValue: valicode.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((valicode).value = $event)),
            type: "digit",
            maxlength: 6,
            border: false,
            center: "",
            "left-icon": "shield-o",
            placeholder: "请输入短信验证码"
          }, {
            button: _withCtx(() => [
              (!showCode.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "orange",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (sendCode()))
                  }, "获取验证码"))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(countTime.value) + "秒", 1))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "login-btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (login()))
          }, "登录"),
          _hoisted_6
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})